module.exports = {
    role: {
        label: 'Users.role',
        placeHolder: 'Users.role'
    },
    firstName: {
        roles: ['Administrateur', 'Chauffeur', 'Dispatch', 'Sous-traitant', 'Sous-traitantExclusif', 'Autre', 'Viewer'],
        label: (role) => role === 'Sous-traitant' ? 'Users.contactFirstName' : 'Users.firstName',
        placeholder: (role) => role === 'Sous-traitant' ? 'Users.contactFirstName' : 'Users.firstName'
    },
    lastName: {
        roles: ['Administrateur', 'Chauffeur', 'Dispatch', 'Sous-traitant', 'Sous-traitantExclusif', 'Autre', 'Viewer'],
        label: (role) => role === 'Sous-traitant' ? 'Users.contactLastName' : 'Users.lastName',
        placeholder: (role) => role === 'Sous-traitant' ? 'Users.contactLastName' : 'Users.lastName'
    },
    phoneNumber: {
        roles: ['Administrateur', 'Chauffeur', 'Dispatch', 'Sous-traitant', 'Sous-traitantExclusif', 'Autre', 'Viewer'],
        label: 'Users.phone',
        placeholder: 'Users.phone'
    },
    email: {
        roles: ['Administrateur', 'Chauffeur', 'Dispatch', 'Sous-traitant', 'Sous-traitantExclusif', 'Autre', 'Viewer'],
        label: 'Users.email',
        placeholder: 'Users.email'
    },
    password: {
        roles: ['Administrateur', 'Chauffeur', 'Dispatch', 'Sous-traitant', 'Sous-traitantExclusif', 'Autre', 'Viewer'],
        label: 'Users.password',
        placeholder: 'Users.password'
    },
    geotabDriver: {
        label: 'Users.geotabDriver',
        placeholder: 'Drivers.select_drivers'
    },
    companyName: {
        roles: ['Sous-traitant', 'Sous-traitantExclusif'],
        label: 'Users.fields.common.companyName',
        placeholder: 'Users.fields.common.companyName'
    },
    tps: {
        roles: ['Sous-traitant', 'Sous-traitantExclusif'],
        label: 'Users.fields.common.tps',
        placeholder: 'Users.fields.common.tps'
    },
    tvq: {
      roles: ['Sous-traitant', 'Sous-traitantExclusif'],
        label: 'Users.fields.common.tvq',
        placeholder: 'Users.fields.common.tvq'
    },
    hiringDate: {
      roles: ['Chauffeur', 'Sous-traitant', 'Sous-traitantExclusif'],
      label: 'Users.fields.common.hiringDate',
      placeholder: 'Users.fields.common.hiringDate'
    },
    driverCountry: {
      roles: ['Chauffeur', 'Sous-traitant', 'Sous-traitantExclusif'],
      label: 'Users.fields.common.driverCountry',
      placeholder: 'Users.fields.common.driverCountry'
    },
    drivingRecord: {
      roles: ['Chauffeur', 'Sous-traitantExclusif'],
      label: 'Users.fields.driver.drivingRecord',
      placeholder: 'Users.fields.driver.drivingRecord',
      dropzone: 'Users.fields.driver.drivingRecordDropZone'
    },
    agreedHourlyRate: {
      roles: ['Chauffeur'],
      label: 'Users.fields.driver.agreedHourlyRate',
      perHours: {
        label: 'Users.fields.driver.agreedHourlyRatePerHour',
        on: {
            label: 'Users.fields.driver.agreedHourlyRateOn'
        },
        drive: {
            label: 'Users.fields.driver.agreedHourlyRateDrive'
        }
      },
      fixedHours: {
        label: 'Users.fields.driver.agreedHourlyRateFixedHours'
      },
      perKM: {
        label: 'Users.fields.driver.agreedHourlyRatePerKM'
      },
      lastModificationDate: {
        label: 'Users.fields.driver.lastModificationDate'
      },
      us: 'United States',
      variables: {
        lower: 'Users.fields.driver.variablesLower',
        upper: 'Users.fields.driver.variablesUpper',
        price: 'Users.fields.driver.variablesPrice',
        validate: 'Users.fields.driver.variablesValidate',
        add: 'Users.fields.driver.variablesAdd'
      },
      selectedField: {
        roles: ['Chauffeur']
      }
    },
    insurance: {
        roles: ['Sous-traitant', 'Sous-traitantExclusif'],
        label: 'Users.fields.common.insurance',
        isInsured: {
            roles: ['Sous-traitantExclusif'],
            label: 'Users.fields.exclusiveSubcontractor.isInsured'
        },
        insuranceAmount: {
            roles: ['Sous-traitantExclusif'],
            label: 'Users.fields.exclusiveSubcontractor.insuranceAmount'
        },
        insuranceDocuments: {
            roles: ['Sous-traitant', 'Sous-traitantExclusif'],
            label: 'Users.fields.common.insuranceDocuments',
            dropzone: 'Users.fields.common.insuranceDocumentsDropZone'
        },
        insuranceExpiration: {
            roles: ['Sous-traitant', 'Sous-traitantExclusif'],
            label: 'Users.fields.common.insuranceExpiration'
        },
        serviceAgreement: {
            roles: ['Sous-traitant'],
            label: 'Users.fields.subcontractor.serviceAgreement',
            placeholder: 'Users.fields.subcontractor.amount'
        }
    },
    fuelCards: {
      roles: ['Chauffeur', 'Sous-traitantExclusif'],
      label: 'Users.fields.driver.fuelCards',
      fueldCardName: 'Users.fields.driver.fuelCardName',
      fueldCardPIN: 'Users.fields.driver.fuelCardPIN'
    },
    driverLicenseClass: {
      roles: ['Chauffeur', 'Sous-traitantExclusif'],
      label: 'Users.fields.driver.driverLicenseClass',
      placeholder: 'Users.fields.driver.driverLicenseClass'
    },
    driverLicense: {
      roles: ['Chauffeur', 'Sous-traitantExclusif'],
      label: 'Users.fields.driver.driverLicense',
      dropzone: 'Users.fields.driver.driverLicenseDropZone'
    },
    driverLicenseExpiration: {
      roles: ['Chauffeur', 'Sous-traitantExclusif'],
      label: 'Users.fields.driver.driverLicenseExpiration',
      placeholder: 'Users.fields.common.documentExpiryPattern'
    },
    passport: {
      roles: ['Chauffeur', 'Sous-traitantExclusif'],
      label: 'Users.fields.driver.passport',
      dropzone: 'Users.fields.driver.passportDropZone'
    },
    passportExpiration: {
      roles: ['Chauffeur', 'Sous-traitantExclusif'],
      label: 'Users.fields.driver.passportExpiration',
      placeholder: 'Users.fields.driver.passportExpiration'
    },
    jockey: {
      roles: ['Chauffeur'],
      label: 'Users.fields.driver.jockey'
    },
    rate: {
      roles: ['Sous-traitantExclusif'],
      label: 'Users.fields.subcontractor.rate',
      rate_description: 'Users.fields.subcontractor.rate_description',
      rateByCar: {
        label: 'Users.fields.subcontractor.rateByCar',
        placeholder: 'Users.fields.subcontractor.amount'
      }
    },
    otherDocuments: {
      label: 'Users.fields.common.otherDocuments',
      roles: ['Chauffeur', 'Sous-traitant', 'Sous-traitantExclusif'],
      otherDocumentName: 'Users.fields.common.otherDocumentsName',
      documentExpiry: 'Users.fields.common.documentExpiryPattern',
      dropzone: 'Users.fields.common.otherDocumentsDropZone'
    }
}
